module.exports = __webpack_public_path__ + "img/columnTransverse.676c12c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/BI/columnTransverse.png
// module id = 1760
// module chunks = 137